import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/config';

export interface CreateBusinessPayload {
  businessName: string;
  tenantId?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  type?: string;
  contactPerson?: string;
  email?: string;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  workspacePlan?: string;
}

interface CreateBusinessResponse {
  success: boolean;
  tenantId: string;
}

const functions = getFunctions(app);

class OnboardingService {
  async createBusiness(payload: CreateBusinessPayload): Promise<CreateBusinessResponse> {
    const createTenantAndBootstrapOwner = httpsCallable(functions, 'createTenantAndBootstrapOwner');
    const result = await createTenantAndBootstrapOwner(payload);
    return result.data as CreateBusinessResponse;
  }
}

export const onboardingService = new OnboardingService();
